import React, { Component } from 'react';
import AlertIcon from '@assets/icons/alert-icon.svg';
import Grid from '@mui/material/Grid2';
import Popup from '../../Popup';
/**
 * Repeated Skill Popup
 */
class ErrorPopup extends Component {
	constructor(props) {
		super(props);
	}
	render() {
		return (
			<Popup show closeButton onClose={() => this.props.hidePopup('showErrorPopup')}>
				<Grid container spacing={2}>
					<Grid size={'auto'}>
						<div className='mx-auto'>
							<img src={AlertIcon} className='mx-auto' alt='' />
						</div>
					</Grid>
					<Grid size={11}>
						<div className='mx-auto'>
							<span className='mx-auto'>{this.props.lan.unexpectedErrorOcurred}</span>
						</div>
					</Grid>
				</Grid>
			</Popup>
		);
	}
}
export default ErrorPopup;
